<template>
  <div>
    <LoadingWidget v-if="loading" />

    <template v-else>
      <v-sheet class="py-6 py-md-8 px-3" color="primary">
        <TitleWidget :small="xsOnly" dark>
          {{ title }}
        </TitleWidget>
      </v-sheet>

      <v-container class="pt-6 pt-md-8 pb-10 pb-md-13 pb-lg-16">
        <template v-if="attachments.length || gallery.length || item.text">
          <img
            v-if="image && item.text"
            class="d-block mb-6 item-img"
            :src="files + image + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
            :alt="title"
            width="100%"
          />

          <img
            v-if="icon"
            class="d-block mb-6 item-img"
            :src="files + icon + '?resize=1&w=' + (xsOnly ? 600 : 1200)"
            :alt="title"
            width="100%"
          />

          <div
            v-if="item.text"
            class="grey--text text-body-1 font-weight-regular ck-content"
            v-html="item.text"
          ></div>

          <AttachmentSection
            v-if="attachments.length"
            :has-title="!!item.text"
            :items="attachments"
          />

          <GallerySection
            v-if="gallery.length > 1"
            :has-title="!!item.text"
            :items="gallery"
          />
        </template>

        <v-alert v-else type="info">{{ noContentText }}</v-alert>
      </v-container>
    </template>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
import AttachmentSection from "../components/sections/AttachmentSection.vue";
import GallerySection from "../components/sections/GallerySection.vue";
import { formatToURL } from "../utils/formatToURL";

const _data = {
  loading: true,
  noContentText: "Nenhum conteúdo adicionado até o momento, volte mais tarde.",
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    mod() {
      return this.$route.meta.mod;
    },
    itemId() {
      return this.$route.params.item;
    },
    item() {
      return this.$rest(this.mod)
        .list.filter(({ title }) => formatToURL(title) === this.itemId)
        .pop();
    },
    title() {
      return this.item.title;
    },
    icon() {
      return this.item?.icon;
    },
    image() {
      return this.item?.img?.featured || "";
    },
    attachments() {
      if (this.item?.attachments?.length) return this.item.attachments;

      return [];
    },
    gallery() {
      if (this.item?.img?.list.length)
        return this.item.img.list.map(({ path, title }) => ({
          src: this.files + path,
          caption: title,
        }));

      return [];
    },
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  watch: {
    item() {
      document.title = `${this.title} | ${this.name}`;
    },
  },
  created() {
    this.$rest(this.mod)
      .get()
      .finally(() => (this.loading = false));
  },
  components: {
    LoadingWidget,
    TitleWidget,
    AttachmentSection,
    GallerySection,
  },
};
</script>

<style lang="scss" scoped>
.item-img {
  max-height: 60vh;
  max-width: 100%;
  object-fit: contain;
}
</style>
